import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { QUERY_KEYS } from '@src/query';
import { userAtom } from '@src/state/userAtom';
import { getLatestUGCAgreedWidget } from './api';

export const useQueryLatestUGCAgreedWidget = (enabled: boolean) => {
  const user = useAtomValue(userAtom);
  const groupKey = user?.group?._id ?? user?.group?.name;

  return useQuery({
    queryKey: QUERY_KEYS.latestUgcWidget(user?._id, groupKey),
    queryFn: getLatestUGCAgreedWidget,
    enabled: enabled && !!user?._id && !!groupKey,
  });
};
